import React from 'react';
import '../../styles/sections/ProductAnalysisSection.css';

const ProductAnalysisSection = () => {
  return (
    <section className="product-analysis-section">
      <div className="pa-container">
        
        {/* LIMITED TIME OFFER Section */}
        <div className="pa-offer-banner">
          <div className="pa-offer-tag">
            ⚡ LIMITED TIME OFFER
          </div>
          
          <h2 className="pa-offer-title">
            Give your business the gift of growth
          </h2>
          
          <p className="pa-offer-description">
            Unlock the tools that power faster decisions, smarter ads, and stronger performance when it matters most.
          </p>
          
          <button className="pa-offer-button">
            Claim your 35% discount
          </button>
        </div>

        {/* Rest of the content */}
        <div className="pa-container">
          
          {/* Achieve sustainable growth Section */}
          <div className="pa-section-header">
            <h1 className="pa-main-title">
              Achieve sustainable growth and increase profits
            </h1>
            <p className="pa-main-subtitle">
              See what's working, act with clarity, and grow without guesswork.
            </p>
          </div>

          <div className="pa-main-grid">
            
            {/* LEFT SIDE - Product Summary */}
            <div className="pa-left-panel">
              
              <div className="pa-panel-header">
                <span className="pa-step-number">1</span>
                <h2 className="pa-panel-title">Product Summary for "BOBGH96PH"</h2>
              </div>

              {/* Main Content Grid */}
              <div className="pa-content-grid">
                
                {/* Left Column */}
                <div>
                  {/* Electronics Section */}
                  <div className="pa-stat-card">
                    <h3 className="pa-stat-label">Electronics</h3>
                    <div className="flex items-baseline gap-2">
                      <span className="pa-stat-value">FTA502</span>
                      <span className="pa-stat-subtext">30-Dry Revenue</span>
                    </div>
                    <div className="text-2xl font-bold text-blue-700">$23,556,345</div>
                    <div className="pa-stat-subtext">Loss base of EUR</div>
                  </div>

                  {/* Rating */}
                  <div className="pa-stat-card">
                    <div className="pa-stat-label">Current Rating</div>
                    <div className="flex items-center gap-2">
                      <span className="text-xl font-bold">4.6</span>
                      <div className="flex">
                        {[...Array(5)].map((_, i) => (
                          <svg key={i} className="w-4 h-4 text-yellow-400" viewBox="0 0 20 20" fill="currentColor">
                            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                          </svg>
                        ))}
                      </div>
                    </div>
                    <div className="pa-stat-subtext">(1,438) Average Reviews</div>
                  </div>

                  {/* Health Score */}
                  <div className="pa-stat-card">
                    <div className="pa-stat-label">Listing Health Score</div>
                    <div className="text-xl font-bold text-green-700">41.90</div>
                    <div className="h-2 bg-gray-200 rounded-full mt-1 overflow-hidden">
                      <div className="h-full bg-green-500 w-2/5"></div>
                    </div>
                    <div className="pa-stat-subtext">Auditors LHS</div>
                  </div>

                  {/* Product Details */}
                  <div className="pa-stat-card">
                    <h4 className="font-medium text-gray-800 mb-2">Product Details</h4>
                    <div className="text-sm space-y-1">
                      <div className="flex justify-between">
                        <span className="text-gray-600">FBA Inc.</span>
                        <span className="font-bold">$5,621</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-600">Central Inc. Drive</span>
                        <span className="font-bold">10</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-600">Avg Inc. Price</span>
                        <span className="font-bold text-blue-700">$25.53</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-600">Avg Last Price</span>
                        <span className="font-bold">$24.9</span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Right Column */}
                <div>
                  {/* Location */}
                  <div className="pa-stat-card">
                    <div className="pa-stat-label">Location: Washington</div>
                    <div className="font-medium">Estonian Sales</div>
                  </div>

                  {/* Quick Stats Grid */}
                  <div className="pa-quick-stats">
                    <div className="pa-quick-stat">
                      <div className="pa-quick-label">Yokseton</div>
                      <div className="pa-quick-value">200</div>
                    </div>
                    <div className="pa-quick-stat">
                      <div className="pa-quick-label">Senior Card</div>
                      <div className="pa-quick-value">100</div>
                    </div>
                    <div className="pa-quick-stat">
                      <div className="pa-quick-label">Non-Conserving</div>
                      <div className="pa-quick-value text-red-600">14.2</div>
                    </div>
                    <div className="pa-quick-stat">
                      <div className="pa-quick-label">Senior Country</div>
                      <div className="pa-quick-value">500</div>
                    </div>
                  </div>

                  {/* X Tool Comps */}
                  <div className="pa-stat-card">
                    <h4 className="font-medium text-gray-800 mb-2">X Tool Comps</h4>
                    <div className="pa-category-tags">
                      {['Electronics', 'Appliances', 'Camera & Photo', 'Home Audio'].map((item) => (
                        <span key={item} className="pa-tag">{item}</span>
                      ))}
                    </div>
                  </div>

                  {/* Demographics */}
                  <div className="pa-demographics-card">
                    <div className="pa-demo-text">40k - Male 80% - 35-44</div>
                    <div className="pa-demo-value">40k C2</div>
                    <div className="pa-demo-stats">
                      <div className="pa-demo-stat">
                        <div className="pa-demo-stat-label">Avg. Views per Video</div>
                        <div className="pa-demo-stat-value">512,624</div>
                      </div>
                      <div className="pa-demo-stat">
                        <div className="pa-demo-stat-label">Items Sold</div>
                        <div className="pa-demo-stat-value text-green-800">6,243</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Bottom Row - Extra Stats */}
              <div className="pa-bottom-stats">
                <div className="pa-bottom-grid">
                  <div className="pa-bottom-item">
                    <div className="pa-bottom-label">Bar Black</div>
                    <div className="pa-bottom-value">Medicare</div>
                  </div>
                  <div className="pa-bottom-item">
                    <div className="pa-bottom-label">12</div>
                    <div className="pa-bottom-value">300</div>
                  </div>
                  <div className="pa-bottom-item">
                    <div className="pa-bottom-label">Additions with Stony</div>
                    <div className="pa-bottom-value">Fullhouse: FBA</div>
                  </div>
                  <div className="pa-bottom-item">
                    <div className="pa-bottom-label">Restaurant: 21, 27, 28, 3.08</div>
                    <div className="pa-bottom-value">Store Inc.: Special Domestic</div>
                  </div>
                </div>
              </div>
            </div>

            {/* RIGHT SIDE - Chrome Extension */}
            <div className="pa-right-panel">
              
              <div className="mb-4">
                <div className="pa-extension-header">
                  <span className="pa-extension-step">2</span>
                  <h2 className="pa-extension-title">
                    ANALYZE PRODUCT POTENTIAL WITH OUR <span className="pa-extension-highlight">FREE</span> CHROME EXTENSION
                  </h2>
                </div>

                <p className="pa-extension-description">
                  From keywords to sales estimates, get the data you need in the moment you need it. It's research, without the research.
                </p>

                <button className="pa-download-button">
                  Download for free
                </button>
              </div>

              {/* New Customers */}
              <div className="pa-new-customers">
                <div className="pa-loading-indicator">
                  <div className="pa-loading-dot"></div>
                  <div className="pa-loading-text">NEW CUSTOMERS LOADING...</div>
                </div>
                <p className="pa-customers-description">
                  Discover the right voices to promote your products and grow your business.
                </p>
                <a href="#" className="pa-learn-more">
                  Learn more 
                  <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                  </svg>
                </a>
              </div>

              {/* Rating Section */}
              <div className="pa-rating-card">
                <div className="mb-3">
                  <div className="pa-users-count">4M+</div>
                  <div className="pa-users-label">E-Commerce Sellers and Counting</div>
                </div>

                <div className="pa-stars">
                  <div className="pa-large-stars">
                    {[...Array(5)].map((_, i) => (
                      <svg key={i} className="pa-star-icon" viewBox="0 0 20 20" fill="currentColor">
                        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                      </svg>
                    ))}
                  </div>
                  <div className="pa-rating-text">Rated 4.5 out of 5 stars</div>
                </div>

                {/* Reviews */}
                <div className="pa-reviews-count">
                  <div className="pa-reviews-number">80</div>
                  <div className="pa-reviews-label">REVIEWS</div>
                </div>

                {/* Rating Bars */}
                <div className="pa-rating-bars">
                  <div className="pa-rating-bar">
                    <div className="pa-bar-value">80</div>
                    <div className="pa-bar-track">
                      <div className="pa-bar-fill green" style={{ width: '80%' }}></div>
                    </div>
                  </div>
                  <div className="pa-rating-bar">
                    <div className="pa-bar-value">60</div>
                    <div className="pa-bar-track">
                      <div className="pa-bar-fill blue" style={{ width: '60%' }}></div>
                    </div>
                  </div>
                </div>

                <div className="pa-bar-labels">
                  <span className="pa-bar-label">Size Ratio</span>
                  <span className="pa-bar-label">Value Index</span>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom Section */}
          <div className="pa-bottom-section">
            
            {/* First Part: 4M+ and Rating */}
            <div className="pa-users-stats">
              <div className="pa-users-title">
                4M+ E-Commerce Sellers and Counting
              </div>
              <div className="pa-users-rating">
                <div className="pa-large-stars">
                  {[...Array(5)].map((_, i) => (
                    <svg key={i} className="pa-large-star" viewBox="0 0 20 20" fill="currentColor">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                    </svg>
                  ))}
                </div>
                <span className="pa-rating-large">Rated 4.5 out of 5 stars</span>
              </div>
            </div>

            {/* Second Part: 3 Steps */}
            <div className="pa-steps-grid">
              <div className="pa-steps-container">
                
                {/* Step 1 */}
                <div className="pa-step-card">
                  <div className="pa-step-number-large">01</div>
                  <h3 className="pa-step-title">
                    Start selling products in any marketplace
                  </h3>
                  <p className="pa-step-description">
                    Launch your store across multiple platforms with our easy setup tools.
                  </p>
                </div>
                
                {/* Step 2 */}
                <div className="pa-step-card">
                  <div className="pa-step-number-large">02</div>
                  <h3 className="pa-step-title">
                    Grow your business and build steady income
                  </h3>
                  <p className="pa-step-description">
                    Scale your operations with data-driven insights and automation.
                  </p>
                </div>
                
                {/* Step 3 */}
                <div className="pa-step-card">
                  <div className="pa-step-number-large">03</div>
                  <h3 className="pa-step-title">
                    Operate with ease and tailored automations
                  </h3>
                  <p className="pa-step-description">
                    Streamline everything from inventory to customer service with AI tools.
                  </p>
                </div>
              </div>
            </div>

            {/* CTA Button */}
            <div className="mt-10">
              <button className="pa-cta-button">
                Start Your Free Trial
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductAnalysisSection;